module.exports = __webpack_public_path__ + "./images/3b3c26680493947d8d271bba90878bce.webp";